/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class ApprovalApi {
    static getInstance() {
        if (!this.instance) this.instance = new ApprovalApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取审批实例列表
    async getApprovalList (param){
        let url = `/api/process/risk/delivery/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取审批实例记录
    async getApprovalRecord (param){
        let url = `/api/process/risk/delivery/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取待审批实例的表单数据
    async getApprovalForm (param){
        let url = `/api/process/risk/delivery/instance/pending/form?instance_code=${param.instance_code}&type=${param.type}`
        let result = await this.getData(url,{},'POST')
        return result
    } 

    // 审批实例通过
    async passApproval (param,instance_code,transaction_code){
        let url = `/api/process/risk/delivery/approval/${instance_code}?transaction_code=${transaction_code}`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 审批实例拒绝
    async refuseApproval (instance_code){
        let url = `/api/process/risk/delivery/reject/${instance_code}`
        let result = await this.getData(url,{},'GET')
        return result
    } 

    // 审批实例关闭
    async closeApproval (instance_code){
        let url = `/api/process/risk/delivery/cancel/${instance_code}`
        let result = await this.getData(url,{},'GET')
        return result
    } 


}

export {
    ApprovalApi
}